// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import { Environment } from './environement.intarface';
const url = window.location.href;
const formatUrl = new URL(url);
export const env = formatUrl.origin.includes('dev.')
  ? '.dev'
  : formatUrl.origin.includes('valid.')
    ? '.valid'
    : '';
export const environment: Environment = {
  api: env
    ? `https://diagnostique.kccyberdefense${env}.tic-nova.com/api`
    : `https://api-staging.kccybersecurity.com/api`,
  host: env ? `https://kccyberdefense${env}.tic-nova.com` : `https://kccybersecurity.com`,
  siteKey: env
    ? '6LfGXGItAAAAAFhtWAf5B8kgT3osdSQXGrm_OvGr'
    : '6LfGXGItAAAAAFhtWAf5B8kgT3osdSQXGrm_OvGr',
  // prettier-ignore
  version: 'RELEASE-APP-VERSION-CI',
  code: 'kcd',
  disableIndexing: env ? true : false,
  env: env === '.dev' ? 'DEV' : env === '.valid' ? 'VALID' : 'PROD',
};
